import HeroText from "../../components/heros/hero-text";
import CardDefault from "../../components/ui/cards/card-default/card-default";
import "./cookiePolicy.scss";

const CookiePolicy = () => {
  return (
    <div className="cookie-policy">
      <HeroText
        title={"Cookie Policy"}
        text={"Informazioni sui cookie utilizzati dal nostro sito web"}
      />
      <section className="cookie-policy__intro">
        <h2 className="cookie-policy__intro-title">
          Cookie Policy di Rotoinfissioni S.r.l.
        </h2>
        <p className="cookie-policy__last-update">
          <span>Ultimo aggiornamento:</span>
          <span>Agosto 2026</span>
        </p>
        <p className="cookie-policy__intro-text">
          Il presente sito web www.rotoinfissioni.it (di seguito “Sito”)
          utilizza esclusivamente cookie tecnici e, previo consenso, cookie di
          terze parti provenienti da Google Maps, al fine di garantire il
          corretto funzionamento delle pagine e migliorare la fruizione dei
          contenuti.
        </p>
      </section>
      <section className="cookie-policy__section">
        <h2 className="cookie-policy__section-title">Cosa sono i cookie</h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="cookie-policy__section-text">
            <span>
              I cookie sono piccoli file di testo che i siti web visitati
              inviano al browser dell'utente, dove vengono memorizzati per
              essere poi ritrasmessi agli stessi siti alla visita successiva.
              Sono utilizzati per far funzionare in modo efficiente il sito, per
              migliorare le prestazioni e per fornire determinate funzionalità.
            </span>
            <span>
              Sono utilizzati per far funzionare in modo efficiente il sito, per
              migliorare le prestazioni e per fornire determinate funzionalità.
            </span>
          </p>
        </CardDefault>
      </section>
      <section className="cookie-policy__section">
        <h2 className="cookie-policy__section-title">
          Tipologie di cookie utilizzati
        </h2>
        <div>
          <h3 className="cookie-policy__section-sub-title">
            1. Cookie tecnici (necessari)
          </h3>
          <CardDefault type={"grey"} width="full-width">
            <p className="cookie-policy__section-text">
              Questi cookie sono essenziali per il funzionamento del Sito e non
              richiedono il consenso dell'utente. Servono, ad esempio, per:
            </p>
            <ul className="cookie-policy__list">
              <li>Garantire la corretta visualizzazione delle pagine;</li>
              <li>
                Ricordare la scelta dell'utente in merito ai cookie non tecnici.
              </li>
            </ul>
          </CardDefault>
        </div>
        <div>
          <h3 className="cookie-policy__section-sub-title">
            2. Cookie di terze parti (Google Maps)
          </h3>
          <CardDefault type={"grey"} width="full-width">
            <p className="cookie-policy__section-text">
              <span>
                Il Sito integra contenuti tramite iframe di Google Maps, un
                servizio di Google LLC (1600 Amphitheatre Parkway, Mountain
                View, CA 94043, USA).
              </span>
              <span>
                Questo servizio può installare cookie di terze parti, anche a
                fini di analisi o profilazione.
              </span>
            </p>
            <p className="cookie-policy__section-text">
              Per maggiori informazioni:
            </p>
            <ul className="cookie-policy__list">
              <li className="cookie-policy__list-link">
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy di Google
                </a>
              </li>
              <li className="cookie-policy__list-link">
                <a
                  href="https://policies.google.com/technologies/cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Uso dei cookie da parte di Google
                </a>
              </li>
            </ul>
          </CardDefault>
        </div>
      </section>
      <section className="cookie-policy__section">
        <h2 className="cookie-policy__section-title">
          LocalStorage del browser
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="cookie-policy__section-text">
            <span>
              Per ricordare la scelta espressa dall'utente in merito
              all'accettazione o al rifiuto dei cookie non tecnici, il Sito
              utilizza il localStorage del browser.
            </span>
            <span>
              Queste informazioni vengono conservate esclusivamente sul
              dispositivo dell'utente, non contengono dati personali e non
              vengono trasmesse a terzi.
            </span>
          </p>
        </CardDefault>
      </section>
      <section className="cookie-policy__section">
        <h2 className="cookie-policy__section-title">Gestione dei cookie</h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="cookie-policy__section-text">
            <span>
              Al primo accesso, un banner informa l'utente sull'uso dei cookie e
              consente di accettare o rifiutare quelli di terze parti.
            </span>
            <span>
              L'utente può modificare la propria scelta in qualsiasi momento
              tramite l'opzione “Gestisci preferenze cookie” presente nel footer
              del Sito.
            </span>
          </p>
        </CardDefault>
      </section>
      <section className="cookie-policy__section">
        <h2 className="cookie-policy__section-title">
          Come disabilitare i cookie dal browser
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="cookie-policy__section-text">
            L'utente può inoltre gestire o eliminare i cookie direttamente dalle
            impostazioni del proprio browser:
          </p>
          <ul className="cookie-policy__list">
            <li className="cookie-policy__list-link">
              <a
                href="https://support.google.com/chrome/answer/95647"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Chrome
              </a>
            </li>
            <li className="cookie-policy__list-link">
              <a
                href="https://support.mozilla.org/it/kb/Eliminare%20i%20cookie"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mozilla Firefox
              </a>
            </li>
            <li className="cookie-policy__list-link">
              <a
                href="https://support.microsoft.com/it-it/windows/gestire-i-cookie-in-microsoft-edge-visualizzare-consentire-bloccare-eliminare-e-usare-168dab11-0753-043d-7c16-ede5947fc64d"
                target="_blank"
                rel="noopener noreferrer"
              >
                Microsoft Edge
              </a>
            </li>
            <li className="cookie-policy__list-link">
              <a
                href="https://help.apple.com/safari/mac/8.0/en.lproj/sfri11471.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Apple Safari
              </a>
            </li>
          </ul>
        </CardDefault>
      </section>
      <section className="cookie-policy__section">
        <h2 className="cookie-policy__section-title">
          Titolare del trattamento
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="cookie-policy__section-text">
            <span style={{ color: "#000000" }}>Rotoinfissioni S.r.l.</span>
            <span>
              Via Vittorio Emanuele II n.41/1 - 35026 Conselve (PD) - Italia
            </span>
            <span>Email: commerciale@rotoinfissioni.it</span>
            <span>PEC: rotoinfissionisrl@pec.it</span>
            <span>P.IVA: 04903730283</span>
          </p>
        </CardDefault>
      </section>
    </div>
  );
};

export default CookiePolicy;
